(function($){
  var increaseNum = {
    init: function(){
      if ($('.numbers').length){
        increaseNum.initIncreaseNum();
      }
    },
    initIncreaseNum: function(){
      var $number = $(".number__title-counter");
      var $win = $(window);
      var $trigger = null;

      function scrollNum() {
        $win.on('scroll', function() {
          window.requestAnimationFrame(function(){
            if ($trigger) {
              clearTimeout($trigger);
            }
            $trigger  = setTimeout(numberGrow, 100);
          });
        });
      }

      function numberGrow() {
        $trigger = null;
        $number.each(function() {
          var $this = $(this);
          var $numberTop = $(this).offset().top;
          var $countTo = $this.attr('data-number');
          var $winBottom = $win.scrollTop() + $win.height();

          if ($winBottom > $numberTop && $countTo != "XX") {
            $({countNum: $this.html()}).animate({
              countNum: $countTo
            },
            {
              duration: 2000,
              easing: 'swing',
              step: function() {
                $this.html(Math.floor(this.countNum));
              },
              complete: function() {
                $this.html($countTo.replace(".", ","));
              }
            });
          }
        });
      }

      scrollNum();

    }
  };
  $(document).ready(increaseNum.init);
})(jQuery);
